import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Home, Map, ShoppingBag, User, UtensilsCrossed } from "lucide-react";
import logo from "../../assets/images/flashpe.png";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const navLinks = [
        { name: "Home", path: "/stores", icon: <Home size={20} /> },
        { name: "Map View", path: "/restaurant-map", icon: <Map size={20} /> },
        // { name: "Orders", path: "/orderpage", icon: <ShoppingBag size={20} /> },
    ];

    return (
        <nav
            className={`fixed top-0 left-0 right-0 z-[1000] transition-all duration-500 ease-[cubic-bezier(0.165,0.84,0.44,1)]  px-[4%] md:px-[5%] bg-[#100b17] 
                ${scrolled && "h-[65px] bg-[#100b17]  shadow-[0_4px_30px_rgba(0,0,0,0.3)] "
                }`}
        >
            <div className="max-w-[1400px] m-auto h-full flex justify-between items-center sticky top-0">
                <Link to="/stores" className="flex items-center gap-2 no-underline" onClick={closeMenu}>
                    <img src={logo} alt="FlashPe" className={`transition-all duration-300 object-contain ${scrolled ? "h-10" : "h-8 md:h-10"}`} />
                    {/* <span className="logo-text">Flash<span>Pe</span></span> */}
                </Link>

                <div className="hidden md:flex items-center gap-3">
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={`flex items-center gap-2 no-underline px-4 py-2 rounded-xl text-[15px] font-medium transition-all duration-300 ${location.pathname === link.path
                                ? "text-[#FCD34D] bg-[#FCD34D1a]"
                                : "text-white/80 hover:text-white hover:bg-white/5"
                                }`}
                        >
                            {link.icon}
                            <span>{link.name}</span>
                        </Link>
                    ))}
                    {/* <Link
                        to="/profile"
                        className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-[#FCD34D] to-[#F59E0B] text-[#100b17] ml-2 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_4px_15px_rgba(252,211,77,0.3)]"
                    >
                        <User size={20} />
                    </Link> */}
                </div>

                <div className="flex md:hidden text-white cursor-pointer transition-transform duration-300 active:scale-90" onClick={toggleMenu}>
                    {isOpen ? <X size={28} /> : <Menu size={28} />}
                </div>
            </div>

            {/* Mobile Menu Overlay */}
            <div className={`fixed left-0 right-0 top-0 bottom-0 bg-[#100b17] z-[999] flex flex-col p-5 overflow-y-auto transition-all duration-500 ease-[cubic-bezier(0.77,0,0.175,1)] ${isOpen
                ? "translate-y-0 opacity-100 pointer-events-auto"
                : "translate-y-[-100%] opacity-0 pointer-events-none"
                } ${scrolled ? "top-[65px]" : "top-10 md:top-[70px]"}`}>
                <div className="flex flex-col gap-[10px]">
                    {navLinks.map((link) => (
                        <Link
                            key={link.path}
                            to={link.path}
                            className={`flex items-center gap-[15px] p-[12px_16px] md:p-[16px_20px] no-underline text-base md:text-lg font-semibold rounded-2xl transition-all duration-200 border ${location.pathname === link.path
                                ? "bg-gradient-to-br from-[#FCD34D1a] to-[#F59E0B0d] border-[#FCD34D4d] text-[#FCD34D]"
                                : "text-white bg-white/[0.03] border-white/[0.05]"
                                }`}
                            onClick={closeMenu}
                        >
                            <span className={`flex items-center justify-center w-8 md:w-10 h-8 md:h-10 rounded-xl transition-colors ${location.pathname === link.path ? "bg-[#FCD34D33]" : "bg-white/[0.05]"
                                }`}>
                                {link.icon}
                            </span>
                            <span>{link.name}</span>
                        </Link>
                    ))}
                    {/* <Link
                        to="/profile"
                        className={`flex items-center gap-[15px] p-[12px_16px] md:p-[16px_20px] no-underline text-base md:text-lg font-semibold rounded-2xl transition-all duration-200 border ${location.pathname === "/profile"
                            ? "bg-gradient-to-br from-[#FCD34D1a] to-[#F59E0B0d] border-[#FCD34D4d] text-[#FCD34D]"
                            : "text-white bg-white/[0.03] border-white/[0.05]"
                            }`}
                        onClick={closeMenu}
                    >
                        <span className={`flex items-center justify-center w-8 md:w-10 h-8 md:h-10 rounded-xl transition-colors ${location.pathname === "/profile" ? "bg-[#FCD34D33]" : "bg-white/[0.05]"
                            }`}>
                            <User size={20} />
                        </span>
                        <span>Profile</span>
                    </Link> */}
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
